import { getRoles } from "@testing-library/react";
import axios from "axios";
import { idText } from "typescript";
import { getName, getToken, getUser } from "../Utils/Common";
import {
    getAPICall,
    getWithParamsAPICall,
    postAPICall,
    postAPICall2,
    putAPICall,
} from "./axiosMethodCalls";

export const getPayment= async (id) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
        };

        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "payments/show/" + id,
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};
export const getAllPayment = async (id) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "payments/getAll",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getAllPaymentSearch = async (date_from, date_to, orNo) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from: date_from,
            date_to: date_to,
            or_no: orNo,
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "payments/getAll",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const markOR= async (id, status) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            payment_id: id,
            export_option: status
        };

        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "payments/exportOption",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const printAsTextFile = async (printerName, file, openCashDrawer, restoType) => {
    try {
        const formData = new FormData();
        formData.append("printer", printerName);
        formData.append("txtfile", file);
        formData.append("open_cashdrawer", openCashDrawer);
       
        const response = await postAPICall2(
            process.env.REACT_APP_LINK + "prints/generateReceipt",
            formData
        )
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
}

export const createPayment = async (orderID, data, discounts, types) => {
    try {
        const discount_amount = discounts.reduce((n, {amount}) => n + amount, 0)
        const pwd_arr = discounts.filter(data=>data.discount_id==="2")
        const seniors_arr = discounts.filter(data=>data.discount_id==="1")
        const others_arr = discounts.filter(data=>data.discount_id!=="1" || data.discount_id!=="2" || data.discount_id!=="3")
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "payments/create/" + orderID,
            {
                requester:getUser(),
                token:getToken(),
                ...types,
                ...data,
                discount: discount_amount,
                discount_ids: discounts.map(data=> 
                    {

                        return data.discount_id

                    }),
                senior_names:seniors_arr.map(data=>
                    {
                       
                            return data.name
                        
                    }),
                pwd_names:pwd_arr.map(data=>
                    {
                     
                            return data.name
                        
                    }),
                other_names:others_arr.map(data=>
                {
                    return data.name
                }),
                senior:seniors_arr.map(data=>
                    {
                    
                            return data.id
                        
                    }),
                pwd:pwd_arr.map(data=>
                    {
                    
                            return data.id
                        
                    }),
                others:others_arr.map(data=>
                    {
                        return data.id
                    }),
            }
        );
     
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};
export const createPaymentMerge = async ( details,  discounts) => {
    try {
        const pwd_arr = discounts.filter(data=>data.type==="pwd")
        const seniors_arr = discounts.filter(data=>data.type==="senior")
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "payments/mergeBills",
            {
                requester:getUser(),
                token:getToken(),
                ...details,
                discount_ids: discounts.map(data=> 
                    {

                        return data.table_id
                        
                    }),
                senior_names:seniors_arr.map(data=>
                    {
                       
                            return data.name
                        
                    }),
                pwd_names:pwd_arr.map(data=>
                    {
                     
                            return data.name
                        
                    }),
                senior:seniors_arr.map(data=>
                    {
                    
                            return data.id
                        
                    }),
                pwd:pwd_arr.map(data=>
                    {
                    
                            return data.id
                        
                    })
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const createPaymentSplit = async (orderID, data, discounts) => {
    try {
        const pwd_arr = discounts.filter(data=>data.type==="pwd")
        const seniors_arr = discounts.filter(data=>data.type==="senior")
      
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "payments/splitBills/" + orderID,
            {
                requester:getUser(),
                token:getToken(),
                ...data,
                bill_type: "by_pax",
                discount_ids: discounts.map(data=> 
                    {

                        return data.table_id
                        
                    }),
                senior_names:seniors_arr.map(data=>
                    {
                       
                            return data.name
                        
                    }),
                pwd_names:pwd_arr.map(data=>
                    {
                     
                            return data.name
                        
                    }),
                senior:seniors_arr.map(data=>
                    {
                    
                            return data.id
                        
                    }),
                pwd:pwd_arr.map(data=>
                    {
                    
                            return data.id
                        
                    })
            }
        );
   
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const createPaymentDutch = async (orderID, data, discounts, orderDetails, grandTotal, paidAmount) => {
    try {
        const pwd_arr = discounts.filter(data=>data.type==="pwd")
        const seniors_arr = discounts.filter(data=>data.type==="senior")

        const response = await postAPICall(
            process.env.REACT_APP_LINK + "payments/splitBills/" + orderID,
            {
                requester:getUser(),
                token:getToken(),
                
                ...data,
                bill_type: "dutch",
                discount_ids: discounts.map(data=> 
                    {

                        return data.table_id
                        
                    }),
                senior_names:seniors_arr.map(data=>
                    {
                       
                            return data.name
                        
                    }),
                pwd_names:pwd_arr.map(data=>
                    {
                     
                            return data.name
                        
                    }),
                senior:seniors_arr.map(data=>
                    {
                    
                            return data.id
                        
                    }),
                pwd:pwd_arr.map(data=>
                    {
                    
                            return data.id
                        
                    }),
                orders_detail_ids:orderDetails.filter((data) => data.is_pay.split("-")[0] === "1").map(data => 
                    {
                        return data.is_pay.split("-")[1]
                    }),
                paid_amount: paidAmount
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

//Multiple Payment
export const createMultiplePayment = async (orderID, types, details, discounts) => {

    try {
        const discount_amount = discounts.reduce((n, {amount}) => n + amount, 0)
        const pwd_arr = discounts.filter(data=>data.discount_name==="pwd")
        const seniors_arr = discounts.filter(data=>data.discount_name==="senior")
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "payments/createMultiple/" + orderID,
            {
                requester:getUser(),
                token:getToken(),
                ...details,
                // ...types,
                discount: 0,
                discount_ids: discounts.map(data=> 
                    {

                        return data.discount_id

                    }),
                senior_names:seniors_arr.map(data=>
                    {
                       
                            return data.name
                        
                    }),
                pwd_names:pwd_arr.map(data=>
                    {
                     
                            return data.name
                        
                    }),
                senior:seniors_arr.map(data=>
                    {
                    
                            return data.id
                        
                    }),
                pwd:pwd_arr.map(data=>
                    {
                    
                            return data.id
                        
                    })
            }
        );
     
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getByItemDiscount = async (orderID, discount, rate, openPrice) => {
    let config = {
        headers: {
            "api-key": "fJcibSRzJQv2NmJmzgnxsgMu56ucqpLBlJIA9FfaQMI9XxQ0Kxm2sEoMQfwisy0b",
        }
    }
    try {
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "orders/computeTotalDiscount", {
                requester: getUser(),
                token: getToken(),
                order_id: orderID,
                open_discount_rate: rate,
                open_discount_amount: discount[0].amount > 0 ? discount[0].amount : openPrice,
                // open_discount_amount: discount.map(data=>{return data.amount}),
                discount_ids: discount.map(data=>{return data.discount_id}),
            }, config
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};

export const cancelSalesInvoice = async (id, orderID) => {
    try {
        const params = new URLSearchParams();
        params.append('authorized_by',id || getUser())
        params.append('updated_by',getUser())
        params.append('token',getToken())
        const response = await putAPICall(
            process.env.REACT_APP_LINK + "payments/void/" + orderID,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const printBase64 = async (printerName, image, open_cashdrawer=0) => {
    try {
        var payload = {
            printer: printerName,
            image: image,
            open_cashdrawer: open_cashdrawer,
        };
       
        const response = await postAPICall2(
            process.env.REACT_APP_LOCAL + "prints/generateReceiptBase64",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const printOpenCashDrawer = async (print) => {
    try {
        var payload = {
            printer: print,
        };
       
        const response = await postAPICall2(
            process.env.REACT_APP_LINK + "prints/openCashdrawer",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getPaymentReport = async (filter) => {
    try {
       
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/payment",
            {...filter, requester: getUser(), token: getToken()}
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
}